import { Form, Input } from "decorator-form";
import { ILayout } from "common/form/fields/layout/ILayoutType";
import { IFragmentLayoutConfig } from "core/components/FragmentLayout";
import { FragmentProvider } from "core/components/FragmentProvider";
import * as generalFragments from "../article/fragments";
import * as articleFragments from "../article/articleFragments";
import * as glossaryFragments from "../article/glossaryFragments";
import * as attachmentFragments from "../article/attachmentFragments";
import * as contributorFragments from "../article/contributorFragments";
import * as commonFragments from "../article/commonFragments";
import * as contributorCardFragments from "../article/contributorCardFragments";
import * as itemContainerFragments from "../article/itemContainerFragments";
import * as parentContainerFragments from "../article/parentContainerFragment";

const generalFragmentsInput = FragmentProvider.getLayoutInput(generalFragments);
const articleFragmentsInput = FragmentProvider.getLayoutInput({
	...articleFragments,
	...commonFragments,
});
const glossaryFragmentsInput = FragmentProvider.getLayoutInput({
	...glossaryFragments,
	...commonFragments,
});
const attachmentFragmentsInput = FragmentProvider.getLayoutInput({
	...attachmentFragments,
	...commonFragments,
});
const contributorFragmentsInput = FragmentProvider.getLayoutInput({
	...contributorFragments,
	...commonFragments,
});

const contributorCardFragmentsInput = FragmentProvider.getLayoutInput({
	...contributorCardFragments,
});

const itemFragmentInput = FragmentProvider.getInput(itemContainerFragments);
const containerFragmentsInput = FragmentProvider.getInput(
	parentContainerFragments
);
@Form({ title: "Article Panel" })
export default class ArticleDeatilsPanelConfig {
	@Input({
		type: generalFragmentsInput,
		title: "Main Layout",
	})
	public mainLayout: ILayout<IFragmentLayoutConfig>;

	@Input({ type: articleFragmentsInput, title: "Article Layout" })
	public layout: ILayout<IFragmentLayoutConfig>;

	@Input({ type: glossaryFragmentsInput, title: "Glossary Layout" })
	public glossaryLayout: ILayout<IFragmentLayoutConfig>;

	@Input({ type: attachmentFragmentsInput, title: "Attachment Layout" })
	public attachmentLayout: ILayout<IFragmentLayoutConfig>;

	@Input({ type: contributorFragmentsInput, title: "Contributor Layout" })
	public contributorLayout: ILayout<IFragmentLayoutConfig>;

	@Input({
		type: contributorCardFragmentsInput,
		title: "Contributor Card Layout",
	})
	public contributorCardLayout: ILayout<IFragmentLayoutConfig>;

	@Input({ type: containerFragmentsInput, title: "Container Type" })
	public containerFragment: string;

	@Input({ type: itemFragmentInput, title: "Item Wrapper Type" })
	public itemFragment: string;
}



// WEBPACK FOOTER //
// ./src/panels/articleDetails/config/ArticleDetailsPanelConfig.ts